import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['label', 'instructions', 'addInstructions', 'removeInstructions']

  connect () {
    this.resize()
  }

  resize () {
    if (this.hasLabelTarget) this.grow(this.labelTarget)
  }

  saveOnLeave (event) {
    if (this.removing || this.submitting) return
    if (this.element.contains(event.relatedTarget)) return

    this.submitting = true
    this.dispatch('saving')
    this.element.requestSubmit()
  }

  submitEnded (event) {
    this.submitting = false
    if (event.detail.success) document.dispatchEvent(new CustomEvent('save:done'))
  }

  markForRemoval () {
    this.removing = true
  }

  toggleInstructions (event) {
    event.preventDefault()
    if (!this.hasInstructionsTarget) return
    const nowHidden = this.instructionsTarget.classList.toggle('hidden')
    if (nowHidden) {
      this.instructionsTarget.querySelectorAll('input, textarea').forEach((el) => { el.value = '' })
    } else {
      this.instructionsTarget.querySelector('input, textarea')?.focus()
    }
    if (this.hasAddInstructionsTarget) this.addInstructionsTarget.classList.toggle('hidden', !nowHidden)
    if (this.hasRemoveInstructionsTarget) this.removeInstructionsTarget.classList.toggle('hidden', nowHidden)
  }

  autosize (event) {
    this.grow(event.target)
  }

  moveOn (event) {
    event.preventDefault()

    if (this.nextControl) {
      this.nextControl.focus()
    } else {
      event.target.blur()
    }
  }

  // Private

  get nextControl () {
    return this.element.querySelector('[data-options-list-target="row"] input') ||
      this.element.querySelector('[data-field-row-target="instructions"]:not(.hidden) input, [data-field-row-target="instructions"]:not(.hidden) textarea')
  }

  grow (el) {
    el.style.height = 'auto'
    if (el.scrollHeight > 0) el.style.height = `${el.scrollHeight}px`
  }
}
